import ColumnAttrSVG from "./svg/column_attribute.svg";

// 6-dot grid (2×3) icon from Attio standalone — used for DataFields nav
const DataFieldsIcon = ({ className, ...props }) => (
  <ColumnAttrSVG className={className} {...props} />
);

export default DataFieldsIcon;
